import React, { useEffect, useState } from "react";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import PersonIcon from "@mui/icons-material/Person";
import DatePicker from "react-datepicker";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const CommonDatePicker2 = ({ fromDate, setFromDate, toDate, setToDate }) => {
  return (
    <>
      <div className="d-flex ac-js gap-2">
        <div className="col-md-2">
          <label className="form-label">From Date</label>
          <DatePicker
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select from date"
          />
        </div>

        {/* To Date */}
        <div className="col-md-2 ">
          <label className="form-label">To Date</label>
          <DatePicker
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select to date"
            minDate={fromDate} // prevent selecting before fromDate
          />
        </div>
      </div>
    </>
  );
};

const SiteDashboard = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user_details"));
  const [dashboardList, setDashboardList] = useState({});
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const primaryColor = "#852e59";
  const cardShadow = "0 8px 20px rgba(0, 0, 0, 0.05)";
  const cardHoverShadow = "0 12px 28px rgba(0, 0, 0, 0.1)";
  const borderRadius = "20px";

  const getDashboard = () => {
    let formdata = new FormData();
    formdata.append("site_id", userData?.knf_company_site_id);
    formdata.append(
      "from_date",
      fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
    );
    formdata.append(
      "to_date",
      toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    );
    post(URL.USER_DASHBOARD, formdata)
      .then((res) => {
        if (res?.status == "success") {
          setDashboardList(res?.dashboard_datas);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getDashboard();
  }, [fromDate, toDate]);

  const navigationHandler = (route, routeProb) => {
    if (route) navigate(route, { state: routeProb ?? {} });
  };

  return (
    <div
      className="dashRightView"
      style={{
        backgroundColor: "#ffffff",
        minHeight: "100vh",
        padding: "24px",
      }}
    >
      {/* Date Picker Section - NO CHANGES */}
      <CommonDatePicker2
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
      />

      {/* Alert Cards Row 1 */}
      <div
        className="d-flex flex-wrap gap-4"
        style={{ marginTop: "24px", marginBottom: "24px" }}
      >
        {/* Total Alert */}
        <div
          onClick={() => {
            navigationHandler("/site-notifications", { tab: "Recent" });
          }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "24px 20px",
            minWidth: "180px",
            flex: "1",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #f0eef0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = cardHoverShadow;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = cardShadow;
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Total Alert
            </h4>
            <div
              style={{
                backgroundColor: `rgba(133, 46, 89, 0.1)`,
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <AlarmOnIcon style={{ color: primaryColor, fontSize: "28px" }} />
            </div>
          </div>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "16px 0 0 0",
            }}
          >
            {dashboardList?.total_alert_count}
          </h2>
        </div>

        {/* New Alert */}
        <div
          onClick={() => {
            navigationHandler("/site-notifications", { tab: "Recent" });
          }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "24px 20px",
            minWidth: "180px",
            flex: "1",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #f0eef0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = cardHoverShadow;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = cardShadow;
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              New Alert
            </h4>
            <div
              style={{
                backgroundColor: "#fff8e7",
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <AlarmOnIcon style={{ color: "#f9a825", fontSize: "28px" }} />
            </div>
          </div>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#f9a825",
              margin: "16px 0 0 0",
            }}
          >
            {dashboardList?.new_alert_count}
          </h2>
        </div>

        {/* Assigned Alert */}
        <div
          onClick={() => {
            navigationHandler("/site-notifications", { tab: "Allocated" });
          }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "24px 20px",
            minWidth: "180px",
            flex: "1",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #f0eef0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = cardHoverShadow;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = cardShadow;
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Assigned Alert
            </h4>
            <div
              style={{
                backgroundColor: "#f3e5f5",
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <AlarmOnIcon style={{ color: "#9c27b0", fontSize: "28px" }} />
            </div>
          </div>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#9c27b0",
              margin: "16px 0 0 0",
            }}
          >
            {dashboardList?.allocated_alert_count}
          </h2>
        </div>

        {/* Closed Alert */}
        <div
          onClick={() => {
            navigationHandler("/site-notifications", { tab: "Closed" });
          }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "24px 20px",
            minWidth: "180px",
            flex: "1",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #f0eef0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = cardHoverShadow;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = cardShadow;
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Closed Alert
            </h4>
            <div
              style={{
                backgroundColor: "#e8f5e9",
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <AlarmOnIcon style={{ color: "#43a047", fontSize: "28px" }} />
            </div>
          </div>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#43a047",
              margin: "16px 0 0 0",
            }}
          >
            {dashboardList?.closed_alert_count}
          </h2>
        </div>
      </div>

      {/* Group Cards Row 2 */}
      <div className="d-flex flex-wrap gap-4" style={{ marginBottom: "24px" }}>
        {/* Group 1 */}
        <div
          onClick={() => {
            navigationHandler("/site-user");
          }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "24px 20px",
            minWidth: "180px",
            flex: "1",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #f0eef0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = cardHoverShadow;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = cardShadow;
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Group 1
            </h4>
            <div
              style={{
                backgroundColor: `rgba(133, 46, 89, 0.1)`,
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <PersonIcon style={{ color: primaryColor, fontSize: "28px" }} />
            </div>
          </div>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "16px 0 0 0",
            }}
          >
            {dashboardList?.group1_count}
          </h2>
        </div>

        {/* Group 2 */}
        <div
          onClick={() => {
            navigationHandler("/site-user");
          }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "24px 20px",
            minWidth: "180px",
            flex: "1",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #f0eef0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = cardHoverShadow;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = cardShadow;
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Group 2
            </h4>
            <div
              style={{
                backgroundColor: `rgba(133, 46, 89, 0.1)`,
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <PersonIcon style={{ color: primaryColor, fontSize: "28px" }} />
            </div>
          </div>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "16px 0 0 0",
            }}
          >
            {dashboardList?.group2_count}
          </h2>
        </div>

        {/* Group 3 */}
        <div
          onClick={() => {
            navigationHandler("/site-user");
          }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "24px 20px",
            minWidth: "180px",
            flex: "1",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "1px solid #f0eef0",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = cardHoverShadow;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = cardShadow;
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Group 3
            </h4>
            <div
              style={{
                backgroundColor: `rgba(133, 46, 89, 0.1)`,
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <PersonIcon style={{ color: primaryColor, fontSize: "28px" }} />
            </div>
          </div>
          <h2
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "16px 0 0 0",
            }}
          >
            {dashboardList?.group3_count}
          </h2>
        </div>
      </div>

      {/* Status Cards Row 3 */}
      <div className="d-flex flex-wrap gap-4" style={{ marginBottom: "24px" }}>
        {/* Device Status */}
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px 24px",
            minWidth: "220px",
            flex: "1",
            border: "1px solid #f0eef0",
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Device Status
            </h4>
            <div
              style={{
                backgroundColor: dashboardList?.device_status
                  ? "#e8f5e9"
                  : "#ffebee",
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <FavoriteIcon
                style={{
                  fontSize: "28px",
                  color: dashboardList?.device_status ? "#43a047" : "#e53935",
                }}
              />
            </div>
          </div>
          <h4
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: dashboardList?.device_status ? "#43a047" : "#e53935",
              margin: "16px 0 0 0",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {dashboardList?.device_status ? "Active" : "Inactive"}
          </h4>
        </div>

        {/* Service Status */}
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px 24px",
            minWidth: "220px",
            flex: "1",
            border: "1px solid #f0eef0",
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              Service Status
            </h4>
            <div
              style={{
                backgroundColor: dashboardList?.service_status
                  ? "#e8f5e9"
                  : "#ffebee",
                borderRadius: "12px",
                padding: "8px",
              }}
            >
              <FavoriteIcon
                style={{
                  fontSize: "28px",
                  color: dashboardList?.service_status ? "#43a047" : "#e53935",
                }}
              />
            </div>
          </div>
          <h4
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: dashboardList?.service_status ? "#43a047" : "#e53935",
              margin: "16px 0 0 0",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {dashboardList?.service_status ? "Active" : "Inactive"}
          </h4>
        </div>
      </div>

      {/* Description Card */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: borderRadius,
          boxShadow: cardShadow,
          border: "1px solid #f0eef0",
          maxWidth: "500px",
        }}
      >
        <div style={{ padding: "20px" }}>
          <h4
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#6c6c6c",
              margin: "0 0 16px 0",
            }}
          >
            Description
          </h4>
          <textarea
            value={dashboardList?.service_error}
            readOnly
            className="input-box"
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              padding: "12px",
              fontSize: "14px",
              border: "1px solid #e0e0e0",
              width: "100%",
              minHeight: "100px",
              resize: "vertical",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SiteDashboard;
